import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionManagerService } from '../session/session-manager.service';
import { Constants } from '../../constant/constants';
import { Router } from '@angular/router';
import { LoaderService } from '../loader.service';
import { ToastService } from 'src/app/shared/services';
import { FirebaseAuthService } from 'src/app/features/user/auth/services/firebase-auth.service';
import { AzureAuthService } from 'src/app/features/user/auth/services/azure-auth.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(
    private sessionManagerService: SessionManagerService,
    private router: Router,
    private readonly loader: LoaderService,
    private readonly flashService: ToastService,
    private readonly firebaseAuth: FirebaseAuthService,
    private readonly azureAuthService: AzureAuthService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userLang = localStorage.getItem('lang') || 'en';
    if (request.url.includes('idpstgcloud.nycenet.edu')) {
      // Pass through the request without any modifications

      return next.handle(request);
    }

    if (request.headers.has('X-Skip-Interceptor')) {
      // Clone the request without the custom header (if needed)
      const newReq = request.clone({
        headers: request.headers.delete('X-Skip-Interceptor'),
      });
      return next.handle(newReq);
    }

    request = request.clone({
      headers: request.headers
        .set('token', `${this.sessionManagerService.getToken()}`)
        .append('Accept', 'application/json')
        .set('Accept-Language', userLang)
        .delete('Content-Type'),
    });
    return next.handle(request).pipe(
      tap(
        () => {
          /* no-op */
        },
        error => {
          if (error instanceof HttpErrorResponse) {
            this.loader.stop();

            const errorMessage = error?.error?.errorMessage;
            if (error.status === Constants.ERROR_CODES.UNATHOURIZED) {
              sessionStorage.removeItem('canvasDataOnrefresh');
              localStorage.removeItem('login');
              this.firebaseAuth.logOutfromFirebase();
              this.azureAuthService.logOutfromAzure();
              this.sessionManagerService.clearMicrosoftLogin();
              this.sessionManagerService.removeCookies();
              this.flashService.showError(errorMessage);
              this.sessionManagerService.setPriceId('free_trial' as string);
              this.router.navigate(['/']).then(() => {
                window.location.reload();
              });
            }
          }
        },
      ),
    );
  }
}
